import { z } from "zod";
import { isoDateTimeString, uuidSchema } from "./common";
import { feedPostingCardSchema } from "./postings";

export const savedJobItemSchema = z.object({
  postingId: uuidSchema,
  savedAt: isoDateTimeString,
  posting: feedPostingCardSchema,
});

export const savedJobListResponseSchema = z.object({
  items: z.array(savedJobItemSchema),
  nextCursor: z.string().nullable(),
});

export const saveJobRequestSchema = z.object({
  postingId: uuidSchema,
});

export const favoriteOrgItemSchema = z.object({
  orgId: uuidSchema,
  favoritedAt: isoDateTimeString,
  org: z.object({
    id: uuidSchema,
    name: z.string(),
    district: z.string(),
    city: z.string(),
    venueType: z.string(),
    bannerPublicUrl: z.string().nullable().optional(),
    logoPublicUrl: z.string().nullable().optional(),
    kycVerified: z.boolean(),
    ratingAvg: z.number().nullable(),
    ratingCount: z.number().int(),
    activePostingsCount: z.number().int(),
  }),
});

export const favoriteOrgListResponseSchema = z.object({
  items: z.array(favoriteOrgItemSchema),
  nextCursor: z.string().nullable(),
});

export const favoriteOrgRequestSchema = z.object({
  orgId: uuidSchema,
});

export type SavedJobItem = z.infer<typeof savedJobItemSchema>;
export type SavedJobListResponse = z.infer<typeof savedJobListResponseSchema>;
export type SaveJobRequest = z.infer<typeof saveJobRequestSchema>;
export type FavoriteOrgItem = z.infer<typeof favoriteOrgItemSchema>;
export type FavoriteOrgListResponse = z.infer<
  typeof favoriteOrgListResponseSchema
>;
export type FavoriteOrgRequest = z.infer<typeof favoriteOrgRequestSchema>;
